import { DeleteIcon, EditIcon, ViewDocumentIcon } from "Assets/icons";
import { CommonToolTip, CstmPagination } from "components/Common/Common";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import ErrorComponent from "components/shared/ErrorComponent";
import TableHeader from "components/shared/FormComponents/TableHeader";
import LoadingIndicator from "components/shared/LoadingIndicator";
import LoadingOverlay from "components/shared/LoadingOverlay";
import TableLayout from "components/TableLayout";
import { CLIENT_TYPE, CLIENT_TYPE_OPTIONS, CONSENT_STATUS_OPTIONS } from "config/constants";
import { APPOINTMENT_FORMS_VIEW, MANAGE_CONSENT_ADD, MANAGE_CONSENT_EDIT } from "config/paths";
import { successMessageToast } from "helpers/common";
import { useLayoutEffect, useState } from "react";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { generatePath, Link, useNavigate } from "react-router-dom";
import { useDeleteConsentFormMutation, useGetConsentFormListQuery } from "store/services/consent";
import { consentFormFilter } from "store/slices/filter";

const ManageConsent = () => {

    const navigate = useNavigate();

    const dispatch = useDispatch();
    const filter = useSelector(state => state?.filter?.consentFormFilter);

    const [modalType, setModalType] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [currentEntry, setCurrentEntry] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [consentList, setConsentList] = useState([]);

    const { data, isLoading, isError, isFetching, refetch } = useGetConsentFormListQuery({ page: currentPage, limit: pageSize, ...filter });
    const totalRecords = data?.totalRecords || 0;
    const totalPages = Math.ceil(totalRecords / pageSize);

    const [deleteConsent, { isLoading: deleteConsentLoading }] = useDeleteConsentFormMutation();

    const column = [
        {
            head: "Title",
            accessor: "title",
            isComponent: true,
            sorter: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-bold themeBlue">{item?.title || "--"}</h6>
            ),
        },
        {
            head: "Consent For",
            accessor: "consent_for",
            isComponent: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-bold themeBlue">{CLIENT_TYPE[item?.consent_for] || "--"}</h6>
            ),
        },
        {
            head: "Status",
            accessor: "status",
            sorter: true,
            isComponent: true,
            component: (item, ind) => (
                <p
                    style={{ width: 80 }}
                    className={`${item.status == "active"
                        ? "greenStatus"
                        : "redStatus"
                        } status fw-bold text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1`}
                >
                    {item.status}
                </p>
            ),
        },
        {
            head: "Action",
            accessor: "",
            isComponent: true,
            component: (item) => (
                <div className="ActnBtn d-flex align-items-center  gap-10">
                    <CommonToolTip
                        text={"Edit"}
                        component={<Button
                            className="p-0"
                            variant="transparent"
                            type="button"
                            onClick={() => navigate(MANAGE_CONSENT_EDIT.replace(":id", item.id))}
                        >
                            <EditIcon />
                        </Button>}
                    />
                    <CommonToolTip
                        text={"Delete"}
                        component={<Button
                            className="p-0"
                            variant="transparent"
                            type="button"
                            onClick={() => {

                                setCurrentEntry(item);
                                setModalType("delete");
                                setShowModal(true);
                            }}
                        >
                            <DeleteIcon />
                        </Button>}
                    />
                     <CommonToolTip
                        text={"View"}
                        component={<Button
                            onClick={() => {
                            navigate(generatePath(APPOINTMENT_FORMS_VIEW, { id: item?.id, mode: "preview"  }))
                            }} 
                            className="btn text-white d-flex align-items-center justify-content-center commonBtnSmall fw-sbold "
                            variant="transparent"
                            type="button"
                        >
                            Preview
                            {/* <ViewDocumentIcon /> */}
                        </Button>}
                        />
                </div>
            ),
        },
    ];

    const handleFilterChange = (key) => (value) => {
        dispatch(consentFormFilter({ ...filter, [key]: value }))
        setCurrentPage(1);
    }

    const handlePageChange = (page) => {
        window.scrollTo(0, 0);
        setCurrentPage(page);
    };

    const resetFilter = () => {
        dispatch(consentFormFilter({ search: "", status: "active", sort: { column: "id", direction: "desc" } }));
        setCurrentPage(1)
    };

    const handleDelete = async () => {
        try {

            setShowModal(false);

            const list = [...consentList];
            const index = consentList?.findIndex(x => x.id === currentEntry?.id);
            delete list[index];
            setConsentList(list.filter(Boolean));

            const result = await deleteConsent(currentEntry?.id);
            if (!result?.error) successMessageToast(result?.data?.message);

        } catch (err) { console.error("error deleting consent form", err); };
    };

    useLayoutEffect(() => {

        if (data?.records) setConsentList(data?.records)
    }, [data]);

    return (
        <>
            <ConfirmationPop
                confirmation={showModal}
                setConfirmation={setShowModal}
                confirmHandler={handleDelete}
                type={"delete"}
            />
            <section className="client position-relative py-4">
                <Container fluid>
                    <Row>
                        <Col lg="12" className="my-2">
                            <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                                <div className="left">
                                    <TableHeader
                                        heading={"Consent Form"}
                                        handleFilterChange={handleFilterChange}
                                        resetFilter={resetFilter}
                                        filter={filter}
                                        searchPlaceholder="Title"
                                        filterComponent={
                                            <>
                                                <li className="">
                                                    <Dropdown
                                                        onSelect={handleFilterChange("consent_for")}
                                                    >
                                                        <Dropdown.Toggle
                                                            variant="transparent"
                                                            className="border-0 d-flex align-items-center  justify-content-center"
                                                            id="dropdown-basic"
                                                        >
                                                            {CONSENT_STATUS_OPTIONS?.find(x => x.value == filter.consent_for)?.label || "Consent For"}
                                                            <span className="icn ms-2">
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="12"
                                                                    height="8"
                                                                    viewBox="0 0 12 8"
                                                                    fill="none"
                                                                >
                                                                    <path
                                                                        d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                                                        fill="black"
                                                                    />
                                                                </svg>
                                                            </span>
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu
                                                            style={{
                                                                maxHeight: "200px",
                                                                overflowY: "scroll"
                                                            }}
                                                        >
                                                            <Dropdown.Item className="forteen" eventKey={""}>All</Dropdown.Item>
                                                            {
                                                                CLIENT_TYPE_OPTIONS?.map((item, index) => {
                                                                    return <Dropdown.Item className="forteen" key={index} eventKey={item.value}>{item?.label}</Dropdown.Item>
                                                                })
                                                            }
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </li>
                                            </>
                                        }
                                    />
                                </div>
                                <div className="right">
                                    <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                                        <li className="">
                                            <Link
                                                to={MANAGE_CONSENT_ADD}
                                                className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
                                            >
                                                <span className="icn me-1">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="19"
                                                        height="19"
                                                        viewBox="0 0 19 19"
                                                        fill="none"
                                                    >
                                                        <mask
                                                            id="mask0_0_4440"
                                                            style={{ maskType: "alpha" }}
                                                            maskUnits="userSpaceOnUse"
                                                            x="0"
                                                            y="0"
                                                            width="19"
                                                            height="19"
                                                        >
                                                            <rect
                                                                width="18.7197"
                                                                height="18.7197"
                                                                fill="#D9D9D9"
                                                            />
                                                        </mask>
                                                        <g mask="url(#mask0_0_4440)">
                                                            <path
                                                                d="M8.57996 13.2594H10.1399V10.1394H13.2599V8.57947H10.1399V5.45951H8.57996V8.57947H5.46V10.1394H8.57996V13.2594ZM9.35995 17.1593C8.28096 17.1593 7.26698 16.9546 6.31799 16.5451C5.369 16.1356 4.54352 15.5799 3.84153 14.8779C3.13954 14.1759 2.58379 13.3504 2.1743 12.4014C1.76481 11.4524 1.56006 10.4384 1.56006 9.35946C1.56006 8.28047 1.76481 7.26649 2.1743 6.3175C2.58379 5.36851 3.13954 4.54303 3.84153 3.84104C4.54352 3.13905 5.369 2.58331 6.31799 2.17381C7.26698 1.76432 8.28096 1.55957 9.35995 1.55957C10.4389 1.55957 11.4529 1.76432 12.4019 2.17381C13.3509 2.58331 14.1764 3.13905 14.8784 3.84104C15.5804 4.54303 16.1361 5.36851 16.5456 6.3175C16.9551 7.26649 17.1598 8.28047 17.1598 9.35946C17.1598 10.4384 16.9551 11.4524 16.5456 12.4014C16.1361 13.3504 15.5804 14.1759 14.8784 14.8779C14.1764 15.5799 13.3509 16.1356 12.4019 16.5451C11.4529 16.9546 10.4389 17.1593 9.35995 17.1593ZM9.35995 15.5994C11.1019 15.5994 12.5774 14.9949 13.7864 13.7859C14.9954 12.5769 15.5999 11.1014 15.5999 9.35946C15.5999 7.61748 14.9954 6.142 13.7864 4.93302C12.5774 3.72404 11.1019 3.11955 9.35995 3.11955C7.61797 3.11955 6.14249 3.72404 4.93351 4.93302C3.72453 6.142 3.12004 7.61748 3.12004 9.35946C3.12004 11.1014 3.72453 12.5769 4.93351 13.7859C6.14249 14.9949 7.61797 15.5994 9.35995 15.5994Z"
                                                                fill="white"
                                                            />
                                                        </g>
                                                    </svg>
                                                </span>{" "}
                                                Add New Form
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="table-outer">
                                {isLoading ? (
                                    <div style={{ height: "200px" }}>
                                        <LoadingIndicator />
                                    </div>
                                ) : isError ? (
                                    <ErrorComponent />
                                ) : (
                                    <>
                                        {(isFetching || deleteConsentLoading) && (
                                            <LoadingOverlay />
                                        )}
                                        <TableLayout
                                            data={consentList}
                                            column={column}
                                            filter={filter}
                                            handleSort={handleFilterChange("sort")}
                                        />
                                    </>
                                )}
                                <CstmPagination
                                    totalPages={totalPages}
                                    activePage={currentPage}
                                    handlePageChange={handlePageChange}
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default ManageConsent;